import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {Button} from "antd";
import {openNotice, config} from 'Utils';
import {waitreceiptList, requestReceipt} from '../../service/shipRequest';
import moment from "moment/moment";

class WaitReceiptQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            rows: [],
            stockType: [
                {"text": "股份本部", "value": "股份本部"},
                {"text": "云南库存", "value": "云南库存"},
                {"text": "四川库存", "value": "四川库存"},
                {"text": "山东库存", "value": "山东库存"},
                {"text": "广东库存", "value": "广东库存"},
                {"text": "新疆库存", "value": "新疆库存"},
                {"text": "河北库存", "value": "河北库存"},
                {"text": "河南库存", "value": "河南库存"},
                {"text": "湖北库存", "value": "湖北库存"},
                {"text": "辽宁库存", "value": "辽宁库存"},
                {"text": "陕西库存", "value": "陕西库存"},
                {"text": "天毅行本部", "value": "天毅行本部"}],
            total: 0,
            loading: false,
            btnLoading: false,
            selectedRowKeysOutside: [],
            searchObj: {
                itemNum: '',
                itemDesc: '',
                txnNumber: '',
                organizationName: '',
                lineStatus: '2',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);

    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        const {searchObj} = this.state;
        waitreceiptList(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                txnNumber: '',
                lineStatus: '',
                organizationName: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            }
        }, () => {
            self.getData();
        })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    bookedDateFrom: value.from,
                    bookedDateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value.trim()}})
        }
    };

    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };

    receiptRow = () => {
        const self = this;
        if (self.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请勾选行再次提交');
            return;
        }
        self.setState({btnLoading: true});
        var selectedRowKeys = self.state.selectedRowKeysOutside;
        var rows = self.state.rows.filter(x => selectedRowKeys.includes(x.lineId));
        var ids = "";
        rows.forEach(item => {
            ids = ids + "," + item.lineId;
        })
        requestReceipt({lineIds: ids.substring(1)}).then(res => {
            if (res.status) {
                openNotice('success', res.message);
                this.setState({btnLoading: false, selectedRowKeysOutside: []}, () => {
                    this.getData();
                })
            } else {
                openNotice('error', res.message);
                this.setState({btnLoading: false})
            }
        });
    }

    exportList() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/shipRequest/waitreceiptListExp`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }


    render() {
        const {
            rows,
            total,
            loading,
            searchObj,
            btnLoading,
            stockType,
            selectedRowKeysOutside
        } = this.state;


        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.itemNum,
                    type: 'default'
                }, {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.itemDesc,
                    type: 'default'
                }, {
                    name: 'txnNumber',
                    label: '转移单号',
                    text: '输入转移单号',
                    defaultValue: searchObj.txnNumber,
                    type: 'default'
                }, {
                    name: 'lineStatus',
                    label: '状态',
                    text: '请选择状态',
                    options: [
                        {value: '2', text: '待接收'},
                        {value: '4', text: '已接收'},
                        {value: '5', text: '接收失败'},
                        {value: '7', text: '接收中'}
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.lineStatus,
                }, {
                    name: 'orderTime',
                    label: '发出时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startBookDate || '',
                        end: searchObj.endBookDate || ''
                    },
                }, {
                    name: 'organizationName',
                    label: '发出组织',
                    text: '选择发出组织',
                    defaultValue: searchObj.organizationName,
                    type: 'select',
                    multiple: false,//支持多选
                    options: stockType
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };


        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'lineId',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '托管单位',
                    dataIndex: 'salesUnitName'
                }, {
                    title: '转移单号',
                    dataIndex: 'txnNumber'
                }, {
                    title: '发出日期',
                    dataIndex: 'sendTransactionDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }, {
                    title: '发出组织',
                    dataIndex: 'organizationName'
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                }, {
                    title: '数量',
                    dataIndex: 'transactionQuantity'
                }, {
                    title: '来源子库',
                    dataIndex: 'sourceSubinvCode'
                }, {
                    title: '目标子库',
                    dataIndex: 'targerSubinvCode'
                }, {
                    title: '接收时间',
                    dataIndex: 'receTransactionDate',
                    render: text => <span>{text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}</span>
                }, {
                    title: '行状态',
                    dataIndex: 'lineStatus',
                    render: text =>
                        <span> {text == '2' ? '待接收' : text == '4' ? '已接收' : text == '5' ? '接收失败' : text == '7' ? '接收中' : ''}</span>

                },
                // {
                //     title: '操作',
                //     dataIndex: 'save',
                //     width: 150,
                //     render: (text, record, index) => {
                //         if (record.lineStatus == '2') {
                //             return (
                //                 <Button style={{background: '#red'}} size={'small'} type="primary" loading={btnLoading}
                //                         onClick={this.receiptRow.bind(this, record, index)}>接收</Button>);
                //         }
                //     },
                // },
            ],
            rows,
            rowSelection: {
                selectedRowKeys: selectedRowKeysOutside,
                onChange: this.onOutsideSelectChange,
                getCheckboxProps: record => ({
                    disabled: record.lineStatus != 2
                })
            },
        };

        return <div className="dms-body">
            <DmsTab options={[`托管库存接收`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div style={{marginBottom: 8}}>
                    <Button type="primary" style={{marginRight: 8}}
                            onClick={this.receiptRow.bind(this)} loading={btnLoading}>请求接收</Button>
                    <Button style={{position: 'absolute', right: 13}} icon="export"
                            onClick={this.exportList.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(WaitReceiptQuery);


// WEBPACK FOOTER //
// ./src/routes/shipRequest/waitReceiptQuery.js